"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const organisms_1 = require("../../../organisms");
const hooks_1 = require("@icr-ui/hooks");
const styles_1 = require("./styles");
const general_1 = require("../../../general");
const icons_1 = require("@icr-ui/icons");
const theme_1 = require("@icr-ui/theme");
const LayoutFilter = props => {
    const { children, isFilterOpen, mobileActionsProps, setIsFilterOpen, hasSidebar } = props;
    const isSmallScreen = (0, hooks_1.useMediaQuery)('(max-width: 883px)');
    const filterRef = (0, hooks_1.useClickOutside)(() => setIsFilterOpen(false), true);
    if (children) {
        if (!isSmallScreen) {
            return ((0, jsx_runtime_1.jsx)(styles_1.StyledFilterBox, { justifyContent: "flex-start", alignItems: "center", gap: "40px", noRound: true, noShadow: true, noWrap: true, children: children }));
        }
        if (isSmallScreen && mobileActionsProps) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(organisms_1.MobileActions, { ...mobileActionsProps, hasSidebar: hasSidebar }), (0, jsx_runtime_1.jsxs)(styles_1.StyledFilterBox, { ref: filterRef, showFilter: isFilterOpen, justifyContent: "flex-start", alignItems: "center", gap: "40px", noRound: true, noShadow: true, noWrap: true, children: [(0, jsx_runtime_1.jsx)(general_1.Button, { variant: "text", iconButton: true, small: true, onClick: () => setIsFilterOpen(false), navigationProps: {
                                    position: 'top-right',
                                }, children: (0, jsx_runtime_1.jsx)(icons_1.CloseIcon, { width: 16, height: 16, color: theme_1.primary.darker }) }), children] })] }));
        }
    }
    return null;
};
exports.default = LayoutFilter;
//# sourceMappingURL=index.js.map